module.exports = __webpack_public_path__ + "img/logo.272c969d.png";